import axios from "axios";
import { getEnvVariables } from "../helpers";

const { REACT_APP_API_URL } = getEnvVariables();

const gosafeApi = axios.create({
  baseURL: REACT_APP_API_URL,
});

gosafeApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");

  config.headers = {
    ...config.headers,
    ...(token ? { Authorization: token } : {}),
  };

  return config;
});

export default gosafeApi;
